import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=522113b9&scoped=true&"
import script from "./AppTemplate.vue?vue&type=script&lang=js&"
export * from "./AppTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AppTemplate.vue?vue&type=style&index=0&id=522113b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522113b9",
  null
  
)

export default component.exports